import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface CalendarMovie {
  id: number;
  title: string;
  original_title: string;
  poster_path: string | null;
  backdrop_path: string | null;
  overview: string;
  vote_average: number;
  vote_count: number;
  genre_ids: number[];
  release_date: string;
  popularity: number;
  original_language: string;
}

export interface CalendarResponse {
  year: number;
  month: number;
  total_results: number;
  upcoming: CalendarMovie[];
  days: Record<string, CalendarMovie[]>;
}

export interface OnThisDayPerson {
  id: number;
  name: string;
  profile_path: string | null;
  known_for_department: string;
  popularity: number;
}

export interface OnThisDayMovie {
  id: number;
  title: string;
  release_date: string;
  poster_path: string | null;
  vote_average: number;
  popularity: number;
}

export interface OnThisDayResponse {
  month: number;
  day: number;
  movies: OnThisDayMovie[];
  people: OnThisDayPerson[];
}

@Injectable({ providedIn: 'root' })
export class CalendarService {
  private apiUrl = `${environment.apiUrl}/calendar`;

  constructor(private http: HttpClient) {}

  getCalendarMovies(year: number, month: number, region: string = 'US'): Observable<CalendarResponse> {
    return this.http.get<CalendarResponse>(`${this.apiUrl}/movies`, {
      params: { year, month, region }
    });
  }

  getOnThisDay(month: number, day: number): Observable<OnThisDayResponse> {
    return this.http.get<OnThisDayResponse>(`${this.apiUrl}/on-this-day`, {
      params: { month, day }
    });
  }
}
